// Thin wrapper around the shared InsuranceVehiclePicker.
// Kept as a named file because several legacy call sites import it.
import React from 'react';
import InsuranceVehiclePicker from '../shared/InsuranceVehiclePicker.jsx';

function VehicleAddTool({ contract, onClose, onSuccess, onMessage }) {
  return (
    <InsuranceVehiclePicker
      contract={contract}
      onClose={onClose}
      onSuccess={onSuccess}
      onMessage={onMessage}
    />
  );
}

export default VehicleAddTool;
